var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 219,
    viewBox: "0 0 256 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.664 67.5561C197.842 53.8172 145.081 9.72836 145.081 9.72836C139.219 4.77281 130.458 5.50614 125.508 11.3617C120.547 17.2172 121.281 25.9784 127.136 30.9339L157.281 56.445H52.775C45.1028 56.445 38.8861 62.6617 38.8861 70.3339C38.8861 78.0061 45.1028 84.2228 52.775 84.2228H101.592L10.9861 153.762C4.90277 158.434 3.75277 167.151 8.42499 173.234C11.1583 176.801 15.2805 178.667 19.4528 178.667C22.4028 178.667 25.375 177.734 27.9028 175.795L83.4361 133.173C83.4194 133.817 83.3305 134.434 83.3305 135.078C83.3305 178.506 119.619 212.001 166.664 212.001C213.708 212.001 253.703 178.506 253.703 135.078C253.703 107.973 238.197 83.2784 216.664 67.5561Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 178.667C199.363 178.667 223.615 156.281 223.615 128.667C223.615 101.053 199.363 78.667 169.448 78.667C139.532 78.667 115.281 101.053 115.281 128.667C115.281 156.281 139.532 178.667 169.448 178.667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M169.444 78.6655C199.361 78.6655 223.611 101.049 223.611 128.665C223.611 156.282 199.361 178.665 169.444 178.665C139.528 178.665 115.278 156.282 115.278 128.665C115.278 101.049 139.528 78.6655 169.444 78.6655ZM169.444 75.8877C138.044 75.8877 112.5 99.5655 112.5 128.665C112.5 157.765 138.044 181.443 169.444 181.443C200.844 181.443 226.389 157.765 226.389 128.665C226.389 99.5655 200.844 75.8877 169.444 75.8877Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M169.441 75.8901C200.841 75.8901 226.385 99.5679 226.385 128.668C226.385 157.768 200.841 181.446 169.441 181.446C138.041 181.446 112.497 157.768 112.497 128.668C112.497 99.5679 138.041 75.8901 169.441 75.8901ZM169.441 73.1123C136.508 73.1123 109.719 98.0345 109.719 128.668C109.719 159.301 136.508 184.223 169.441 184.223C202.374 184.223 229.163 159.301 229.163 128.668C229.163 98.0345 202.374 73.1123 169.441 73.1123Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.44 156.443C186.316 156.443 199.996 144.007 199.996 128.665C199.996 113.324 186.316 100.888 169.44 100.888C152.565 100.888 138.885 113.324 138.885 128.665C138.885 144.007 152.565 156.443 169.44 156.443Z",
    fill: "#0370C8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M169.445 98.1108C187.823 98.1108 202.778 111.816 202.778 128.666C202.778 145.516 187.823 159.222 169.445 159.222C151.067 159.222 136.112 145.516 136.112 128.666C136.112 111.816 151.067 98.1108 169.445 98.1108ZM169.445 95.333C149.534 95.333 133.334 110.289 133.334 128.666C133.334 147.044 149.534 162 169.445 162C189.356 162 205.556 147.044 205.556 128.666C205.556 110.289 189.356 95.333 169.445 95.333Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M169.449 100.89C186.326 100.89 200.004 113.329 200.004 128.668C200.004 144.007 186.326 156.446 169.449 156.446C152.571 156.446 138.893 144.007 138.893 128.668C138.893 113.329 152.571 100.89 169.449 100.89ZM169.449 98.1123C151.071 98.1123 136.115 111.818 136.115 128.668C136.115 145.518 151.071 159.223 169.449 159.223C187.826 159.223 202.782 145.518 202.782 128.668C202.782 111.818 187.826 98.1123 169.449 98.1123Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.55277,
    y1: 109.223,
    x2: 253.703,
    y2: 109.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlender);
export default __webpack_public_path__ + "static/media/blender.b96901d176f9da66b800d3f5eeb92589.svg";
export { ForwardRef as ReactComponent };